export const getProfileImage = (url) => {
  if (
    !url ||
    url === null ||
    url === undefined
  ) {
    return "/images/default_profile.png";
  }
  return url;
};

export const getMediaUrl = (url) => {
  if (!url) return "";

  // If already a full URL, return as-is
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }

  // Remove leading slash to avoid double slashes
  const cleanPath = url.startsWith("/") ? url.slice(1) : url;

  return `${process.env.REACT_APP_MEDIA_BASE_URL}${cleanPath}`;
};

export const CheckIfNullOrUndefined = (value) => {
  if (
    !value ||
    value === null ||
    value === undefined
  ) {
    return true;
  }
  return false;
};

export const getVideoDuration = (file) => {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");

    video.preload = "metadata";
    video.src = URL.createObjectURL(file);

    video.onloadedmetadata = () => {
      URL.revokeObjectURL(video.src);
      resolve(video.duration); // seconds
    };

    video.onerror = () => reject("Invalid video file");
  });
};

export const formatDate = (
  isoString,
  locale = "en-GB",
  options = { day: "2-digit", month: "short", year: "numeric" }
) => {
  if (!isoString) return "";

  return new Date(isoString).toLocaleDateString(locale, options);
};

export const formatDuration = (totalSeconds) => {
  if (totalSeconds == null || isNaN(totalSeconds) || totalSeconds < 0) {
    return "0 seconds";
  }

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const parts = [];

  if (hours > 0) {
    parts.push(`${hours} hour${hours !== 1 ? "s" : ""}`);
  }

  if (minutes > 0) {
    parts.push(`${minutes} minute${minutes !== 1 ? "s" : ""}`);
  }

  if (seconds > 0 || parts.length === 0) {
    parts.push(`${seconds} second${seconds !== 1 ? "s" : ""}`);
  }

  return parts.join(" ");
};

export const capitalizeFirstLetter = (str = "") => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export function secondsToHourMinute(seconds) {
  if (!seconds || seconds < 0) return "0h 0m";

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  return `${hours}h ${minutes}m`;
}

export function removeBaseUrl(url) {
    if (!url) return url;

    return url.replace(process.env.REACT_APP_MEDIA_BASE_URL, "");
};

export const formatChatDate = (date) => {
  return new Date(date).toLocaleDateString("en-US", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

export const groupMessagesByDate = (messages) => {
  return messages.reduce((acc, msg) => {
    const dateKey = formatChatDate(msg.createdAt);

    if (!acc[dateKey]) {
      acc[dateKey] = [];
    }

    acc[dateKey].push(msg);
    return acc;
  }, {});
};

export const getFileType = (file) => {
  if (file.type.startsWith("image/")) return "image";
  if (file.type.startsWith("video/")) return "video";
  return "unknown";
};